import { useMemo } from 'react';
import { useField } from 'formik';

import GenericCheckBox from '../GenericCheckbox';

const CheckBox = ({
    id,
    name,
    label,
    tooltip,
    buttonTooltip = false,
    onChange,
    disabled,
    css,
    ...props
}) => {
    const [field, meta, { setValue, }] = useField(name);

    const error = useMemo(() => {
        if (meta.touched && meta.error) {
            return <div className='text-danger small'>{meta.error}</div>;
        }

        return null;
    }, [meta]);

    return (
        <div className={css}>
            <GenericCheckBox
                id={id}
                label={label}
                tooltip={tooltip}
                buttonTooltip={buttonTooltip}
                initialValue={field.value}
                onChange={(value) => {
                    if (onChange) {
                        onChange(!field.value);
                    }
                    setValue(!field.value)
                }}
                disabled={disabled}
                {...props}
            />
            {error}
        </div>
    );
};

export default CheckBox;